<!-- ======= Sidebar ======= -->
<aside id="sidebar" class="sidebar">
  <div class="text-center" *ngIf="userPlan!=''">
    <h4><span class="badge bg-secondary"><i class="bi bi-star me-1"></i> {{userPlan}}</span></h4>
  </div>
  <ul class="sidebar-nav" id="sidebar-nav">

    <li class="nav-item" [routerLinkActive]="['link-active']">
      <a class="nav-link" [routerLink]="['/manage-sites']" [ngClass]="{'collapsed': path != '/manage-sites'}">
        <i class="bi bi-gear"></i>
        <span>Manage Sites</span>
      </a>
    </li>
    <li class="nav-item" [routerLinkActive]="['link-active']">
      <a class="nav-link" [routerLink]="['/auto-index-queue']" [ngClass]="{'collapsed': path != '/auto-index-queue'}">
        <i class="bi bi-view-stacked"></i>
        <span>Auto Index Queue</span>
      </a>
    </li>
    <li class="nav-item cursor-pointer">
      <a class="nav-link collapsed" data-bs-toggle="modal" data-bs-target="#reportIssueModal">
        <i class="bi bi-exclamation-circle"></i>
        <span>Report Issue</span>
      </a>
    </li>
  </ul>
</aside><!-- End Sidebar-->

<app-generic-modal modalTitle="Report Issue" modalId="reportIssueModal">
  <p>
    If you stumble upon any bugs, glitches, or simply have a suggestion for improvement, please let us know! Here's how:
  </p>
  <ul>
    <li>
      Direct Message: Reach out to our support team via direct message on X here: <a _ngcontent-ng-cli-universal-c1128775717="" href="https://twitter.com/rankaheadapp" class="twitter h5"><i _ngcontent-ng-cli-universal-c1128775717="" class="bi bi-twitter"></i></a>
    </li>
    <li>
      Email: Send us an email detailing the issue you encountered at
      <span class="badge bg-secondary cursor-pointer" (click)="copyTextToClipboard()"><i class="bi bi-copy me-1"></i> support&#64;rankahead.app</span>

    </li>
  </ul>

  <p>
    Rest assured, our team is dedicated to swiftly resolving any issues you encounter. Your satisfaction is our top priority, and we appreciate your collaboration in making our tool even better!
  </p>
  <p>
    Thank you for being a valued member of our community.
  </p>


</app-generic-modal>

<app-alert [showMessage]="showMessage" [message]="message" [alertType]="alertType">
</app-alert>
